/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ValidateAutomationUpdateMutationRequest,
  ValidateAutomationUpdateMutationResponse,
  ValidateAutomationUpdatePathParams,
  ValidateAutomationUpdate400,
} from '../types/ValidateAutomationUpdate'

function getValidateAutomationUpdateUrl({
  automation_id,
  company_id,
}: {
  automation_id: ValidateAutomationUpdatePathParams['automation_id']
  company_id: ValidateAutomationUpdatePathParams['company_id']
}) {
  const res = {
    method: 'POST',
    url: `/api/v1/automations/validation/company/${company_id}/automation/${automation_id}/validate-update/` as const,
  }
  return res
}

/**
 * @description Validate that updating an automation won't create cycles.
 * POST /automations/validation/company/{company_id}/automation/{automation_id}/validate-update/
 * Body: {
 * "trigger_type": "field_changed_sales_stage",
 * "action_type": "change_account_owner"
 * }
 * @summary Validate that an automation update won't create cycles
 * {@link /api/v1/automations/validation/company/:company_id/automation/:automation_id/validate-update/}
 */
export async function validateAutomationUpdate(
  {
    automation_id,
    company_id,
  }: {
    automation_id: ValidateAutomationUpdatePathParams['automation_id']
    company_id: ValidateAutomationUpdatePathParams['company_id']
  },
  data: ValidateAutomationUpdateMutationRequest,
  config: Partial<RequestConfig<ValidateAutomationUpdateMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ValidateAutomationUpdateMutationResponse,
    ResponseErrorConfig<ValidateAutomationUpdate400>,
    ValidateAutomationUpdateMutationRequest
  >({
    method: 'POST',
    url: getValidateAutomationUpdateUrl({
      automation_id,
      company_id,
    }).url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
